import React from "react";
import {DashboardComponent} from "react-admin";
import {NotificationsList} from "../resources/notifications/List";

export const Dashboard: DashboardComponent = props => (
    <>
        <NotificationsList />
    </>
);
